function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Brand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.385 7.011h-1.777V3H22v4.011h-1.853V21h-4.402c-1.184 0-1.596-.308-2.137-1.311l-4.813-8.95h-.128v6.25h1.905V21H2v-4.011h1.905V7.01H2V3h6.872c1.185 0 1.596.308 2.137 1.311l4.247 7.895h.129V7.01z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Brand);
export default ForwardRef;